import type { IconSvgObject } from './types';

const FlagTriangleRightIcon: IconSvgObject = [
  ["path", { d: "M5 16V2.81992C5 2.36709 5.36709 2 5.81992 2C5.93856 2 6.05579 2.02575 6.16351 2.07547L18.5382 7.78684C18.8197 7.91678 19 8.19858 19 8.50867C19 8.80979 18.8299 9.08507 18.5605 9.21973L5 16ZM5 16V22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default FlagTriangleRightIcon;
